import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['content', 'trigger']
  
  toggle(event) {
    event.preventDefault();
    this._isHidden() ? this.show(event) : this.hide(event)
  }
  
  show(event) {
    event.preventDefault();
    this.triggerTarget.classList.add('active')
    this.contentTarget.classList.remove('hide')
  }
  
  hide() {
    this.triggerTarget.classList.remove('active')
    this.contentTarget.classList.add('hide')
  }
  
  clickAway(event) {
    if (this.triggerTarget !== event.target) { this.hide(event) }
  }
  
  // private
  
    _isHidden() {
      return this.contentTarget.classList.contains('hide')
    }
}